export default class CoursePurchaseForm {
    public coursePurchaseId: number
    public token: string
    public email: string
}